import { SvgIcon } from "@/components/icon"
import { FC } from "react"
import "./EasetechLogoSpinner.less"

const EasetechLogoSpinner: FC = () => {
  return (
    <div className={"easetech-logo-wrapper"}>
      <div className={"easetech-logo-card"}>
        <div className={"easetech-logo-face front"}>
          <SvgIcon type={"logo"} />
        </div>
        <div className={"easetech-logo-face back"}>
          <SvgIcon type={"logo-dark-blue-flipped"} />
        </div>
      </div>
    </div>
  )
}

export default EasetechLogoSpinner
